import axios from '../utils/axios.util'

function apiGetRefrnCode(mtrqlt) {
    return axios.get(`/api/v1/scanner/refrn-code?REFRN_NM=${mtrqlt}`)
}

function apiWarehousing(formData) {
    return axios.post('/api/v1/scanner/ware-housing', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
}

export { apiGetRefrnCode, apiWarehousing }
